module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDIgMzkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDAuNVYzOC41IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8zOTFfMzAzOSkiIHN0cm9rZS13aWR0aD0iMiIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzM5MV8zMDM5IiB4MT0iMS41IiB5MT0iMC41IiB4Mj0iMS41IiB5Mj0iMzguNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcC8+CjxzdG9wIG9mZnNldD0iMC41NCIgc3RvcC1jb2xvcj0iI0QzRDNEMyIvPgo8c3RvcCBvZmZzZXQ9IjEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/background.svg
// module id = BeA3
// module chunks = 0